import { render, staticRenderFns } from "./InvoiceDetail.vue?vue&type=template&id=b03023b8&scoped=true&"
import script from "./InvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetail.vue?vue&type=style&index=0&id=b03023b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03023b8",
  null
  
)

export default component.exports